class RecordCommand {
    constructor(recorder) {
        this.recorder = recorder;
    }

    run(config) {
        this.recorder.start(config);
    }
}

export default RecordCommand;
